<template>
  <v-app class="app">
    <div>
      <visitor-identification />
      <placeholder name="jssheader" v-if="this.displayHeader" :rendering="route" />
      <placeholder class="jssmain" :key="Date.now()" name="jssmain" :rendering="route" :errorComponent="JssMainError" />
      <placeholder v-if="this.displayFooter" name="jssfooter" :rendering="route" />
    </div>
    <UserActivityTracker />
  </v-app>
</template>

<script>
import UserActivityTracker from './components/ActivityTracker/UserActivityTracker';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import VisitorIdentification from './VisitorIdentification';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import JssMainError from './components/JssMainError/JssMainError'

export default {
  name: 'Layout',
  props: {
    route: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {JssMainError: JssMainError};
  },
  components: {
    Placeholder,
    VisitorIdentification,
    UserActivityTracker,
  },
  computed: {
    displayHeader() {
      return this.route.placeholders['jssheader'] || isExperienceEditorActive();
    },
    displayFooter() {
      return this.route.placeholders['jssfooter'] || isExperienceEditorActive();
    },
  },
};
</script>
